import React from "react";
import { Modal, Button } from "react-bootstrap";
const ConfirmAddArticlesModal = ({
  showModal,
  setShowModal,
  countEmptyArticles,
  handleContinue,
  payloadArticles,
  setIsSubmitingArticles,
}) => {
  return (
    <Modal
      className="modal-dialog-centered overflow-hidden"
      show={showModal}
      onHide={() => setShowModal(false)}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="m-auto">
        <Modal.Title>Confirm Action</Modal.Title>
      </Modal.Header>
      <Modal.Body className="m-auto text-center">
        <div>
          <p>
            <strong>{countEmptyArticles} Articles</strong>{" "}
            {`have empty abstracts or titles. They will be removed.`}
          </p>
        </div>
        <div>
          <p>Would you like to continue?</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="m-auto">
        <Button
          variant="secondary"
          onClick={() => {
            setShowModal(false);
            setIsSubmitingArticles(false);
          }}
        >
          Cancel
        </Button>
        <Button
          className="modal-primary-btn"
          onClick={() => {
            handleContinue(payloadArticles);
            setShowModal(false);
          }}
        >
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmAddArticlesModal;
